import React from 'react'
import DrSoniaShaguftaCV from '../../../assets/F_Social_science_Cv/Psychology/Dr Sonia Shagufta CV.pdf'
import DrSaimaCV from '../../../assets/F_Social_science_Cv/Psychology/DrSaimaCV.pdf'
import TeacherCard from '../../../Components/TeacherCard'
import MegaNavbar from '../../../Components/MegaNavbar'
import Footer from '../../../Components/Footer'

const Psychology = () => {
  return (
    <>
     <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Psychology</h2>
        
        <p>Faculty of Psychology.</p>
      </div>

      <div className="row">

<TeacherCard 
name=' Dr. Sonia Shagufta '
profile_name='Assistant Professor, Department of  Psychology'
intro=' Assistant Professor Department of Psychology Shaheed Benazir Bhutto Women University Peshawar'
email=' : sonia.shagufta@sbbwu.edu.pk '
cv={DrSoniaShaguftaCV }
google='https://www.google.com/'
linkedin=''


/>
<TeacherCard 
name=' Dr. Saima Parwez '
profile_name='Assistant Professor, Department of  Psychology '
intro='Assistant Professor HEC Approved Supervisor Department of Psychology Shaheed Benazir Bhutto Women University Peshawar '
email=': saimapervez@sbbwu.edu.pk '
cv={DrSaimaCV}
google='https://www.google.com/'
linkedin=''


/>
      
</div> 

</div>
</section>



  <Footer/>

      
    </>
  )
}

export default Psychology
